import React from "react";
import modalpopup from "../../assets/images/modalPopubg.svg";
import Lottie from "react-lottie";

import { ModalPopUp } from "../ModalPopUp/ModalPopUp";

const ModalData =({heading1,lottieOptions,onClickCancel = () => {},onClickConfirm = () => {}, style={}})=>{

    
    return(
        <>
        <ModalPopUp>
        <div
          className="modal-popup"
          style={{
            backgroundImage: `url(${modalpopup})`,
            backgroundRepeat: "no-repeat",
            backgroundPositionX: "right",
            backgroundPositionY: "bottom",
            height: "270px",
           ...style
          }}
        >
          <div className="mt-20">
            <Lottie options={lottieOptions} height={80} width={80}></Lottie>
          </div>

          <div className="flex justify-center ">
            <label className="fs25 blue_font fw-bold">Are you sure!</label>
          </div>
          <div className="flex justify-center">
            <label>{heading1}</label>
          </div>
          <div className="flex justify-center gap-10 mt-30">
            <button
            onClick={onClickCancel}
              className="cancel_button"
            >
              No, Cancel it
            </button>
            <button
            onClick={onClickConfirm}
              className="confirm_button"
            >
              Yes, I am sure!
            </button>
          </div>
        </div>
      </ModalPopUp></>
    )
}

export default ModalData